var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "factoid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "factoid__decorate"
  }), _vm._v(" "), _c('div', {
    staticClass: "factoid__text-wrap"
  }, [_c('ul', {
    staticClass: "factoid__list"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "factoid__list-item"
  }, [_c('img', {
    staticClass: "factoid__list-item-icon",
    attrs: {
      "src": require("./asset/jet.svg"),
      "alt": "Быстрая доставка"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "factoid__list-item-text"
  }, [_c('h5', {
    staticClass: "factoid__list-item-title"
  }, [_vm._v("Быстрая доставка")]), _vm._v(" "), _c('p', {
    staticClass: "cc-p grey-text factoid__list-item-text"
  }, [_vm._v("\n            Подробнее на\n            "), _c('GGLink', {
    staticClass: "factoid__link",
    attrs: {
      "to": "/about/delivery/"
    }
  }, [_vm._v("\n              странице доставки\n            ")])], 1)])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "factoid__top"
  }, [_c('img', {
    staticClass: "factoid__car",
    attrs: {
      "src": require("./asset/car.svg"),
      "alt": "Машина"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "factoid__list-item"
  }, [_c('img', {
    staticClass: "factoid__list-item-icon",
    attrs: {
      "src": require("./asset/truck.svg"),
      "alt": "Доставка"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "factoid__list-item-text"
  }, [_c('h5', {
    staticClass: "factoid__list-item-title"
  }, [_vm._v("Бесплатная доставка")]), _vm._v(" "), _c('p', {
    staticClass: "cc-p grey-text factoid__list-item-text"
  }, [_vm._v("\n            При заказе от 999₽ доставим"), _c('span', {
    staticClass: "factoid__br"
  }), _vm._v("\n            совершенно бесплатно\n          ")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "factoid__list-item"
  }, [_c('img', {
    staticClass: "factoid__list-item-icon",
    attrs: {
      "src": require("./asset/box.svg"),
      "alt": "Самовывоз"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "factoid__list-item-text"
  }, [_c('h5', {
    staticClass: "factoid__list-item-title"
  }, [_vm._v("Доставим сегодня")]), _vm._v(" "), _c('p', {
    staticClass: "cc-p grey-text factoid__list-item-text"
  }, [_vm._v("\n            При оформлении заказа до 17:00\n          ")])])]);
}]

export { render, staticRenderFns }